import isStorybook from './isStorybook';

export default isStorybook;
